import request from '@/api/request'

// 查询退款周期信息
export const getRefundPeriodStatistics = (params) => {
  return request({
    url: '/statistics/adm/baseOrderData/getRefundPeriodStatistics',
    method: 'get',
    params
  })
}
/**
 * 获取租户列表
 */
export const getAvailableCompanyList = (data) => {
  return request({
    url: 'base/adm/company/getAvailableCompanyList',
    method: 'post',
    data
  })
}
/**
 * 集团产品退费信息
 */
export const getAllSpuRefund = (params) => {
  return request({
    url: 'statistics/adm/spuPlatformStatistics/getListPage',
    method: 'get',
    params
  })
}
/**
 * 事业部产品退费信息
 */
export const getSingleSpuRefund = (params) => {
  return request({
    url: 'statistics/adm/spuRefundStatistics/getListPage',
    method: 'get',
    params
  })
}
/**
 * 集团班级退费信息
 */
export const getAllSkuRefund = (params) => {
  return request({
    url: 'statistics/adm/skuPlatformStatistics/getListPage',
    method: 'get',
    params
  })
}
/**
 * 事业部班级退费信息
 */
export const getSingleSkuRefund = (params) => {
  return request({
    url: 'statistics/adm/skuRefundStatistics/getListPage',
    method: 'get',
    params
  })
}

// 退费基础数据列表
export const getRefundBaseDataListPage = (params) => {
  return request({
    url: 'refund/adm/refundBaseData/getListPage',
    method: 'get',
    params
  })
}

// 更新退款基础数据状态
export const updateRefundBaseDataStatus = (data) => {
  return request({
    url: 'refund/adm/refundBaseData/updateStatus',
    method: 'post',
    data
  })
}

// 添加退费基础数据
export const addRefundBaseData = (data) => {
  return request({
    url: 'refund/adm/refundBaseData/addRefundBaseData',
    method: 'post',
    data
  })
}

// 添加服务支持人员
export const addSupportUsers = (data) => {
  return request({
    url: 'refund/adm/supportUser/addSupportUsers',
    method: 'post',
    data
  })
}

// 分页查询服务支持人员审核统计
export const getSupportUserStatisticsListPage = (params) => {
  return request({
    url: 'refund/adm/supportUserStatistics/getListPage',
    method: 'get',
    params
  })
}

// 获取所有用户列表
export const allCompanyUserWithDept = (params) => {
  return request({
    url: 'base/user/allCompanyUserWithDept',
    method: 'get',
    params
  })
}

// 查询服务支持人员
export const getSupportUserList = (params) => {
  return request({
    url: 'refund/adm/supportUser/getListPage',
    method: 'get',
    params
  })
}

